module.exports = __webpack_public_path__ + "img/event_name.2d185f14.png";